import React, { useState } from "react";
import { Box, Typography, Button, IconButton, Tooltip, TextField, MenuItem } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DataTable from "../components/DataTable";
const orderStatuses = ["Pending", "Contacted", "Order Completed", "Order Pending", "Order Failed"];
export default function Orders() {
    const [orders, setOrders] = useState([
        {
            orderId: "ORD001",
            orderDate: "2026-03-06",
            userName: "John Doe",
            mobile: "9876543210",
            address: "123 Main Street, Erode",
            status: "Pending",
            remarks: "",
            products: [{ name: "Gold Ring", quantity: 2 }, { name: "Silver Chain", quantity: 1 }]
        },
        {
            orderId: "ORD002",
            orderDate: "2026-03-05",
            userName: "Jane Smith",
            mobile: "9123456780",
            address: "456 Park Avenue, Erode",
            status: "Order Completed",
            remarks: "Urgent delivery",
            products: [{ name: "Diamond Earrings", quantity: 1 }]
        }
    ]);
    const [open, setOpen] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [form, setForm] = useState({});
    const openEdit = (index) => {
        setForm(orders[index]);
        setEditIndex(index);
        setOpen(true);
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };
    const handleProductChange = (i, field, value) => {
        const updated = [...form.products];
        updated[i][field] = value;
        setForm({ ...form, products: updated });
    };
    const saveOrder = () => {
        const updated = [...orders];
        updated[editIndex] = form;
        setOrders(updated);
        setOpen(false);
    };
    const columns = ["S.No", "Order ID", "Order Date", "User Name", "Mobile", "Status", "Products", "Action"];
    const rows = orders.map((o, i) => [i + 1, o.orderId, o.orderDate, o.userName, o.mobile, o.status,
    <Box>{o.products.map((p, idx) => <div key={idx}>{p.name} (Qty: {p.quantity})</div>)}</Box>,
    <Box>
        <Tooltip title="Edit">
            <IconButton color="primary" onClick={() => openEdit(i)}><EditIcon /></IconButton>
        </Tooltip>
    </Box>
    ]);
    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 500 }}>Orders</Typography>
            <DataTable columns={columns} rows={rows} loading={false} />
            {open && (
                <Box sx={{ position: "fixed", top: 50, left: 0, width: "100%", height: "100%", bgcolor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1200 }}>
                    <Box sx={{ bgcolor: "#fff", p: 3, borderRadius: 2, width: 1000, maxHeight: "75vh", overflowY: "auto" }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>Edit Order</Typography>
                        <TextField label="Order ID" name="orderId" fullWidth value={form.orderId} onChange={handleChange} sx={{ mb: 2 }} disabled />
                        <TextField label="Order Date" type="date" name="orderDate" fullWidth InputLabelProps={{ shrink: true }} value={form.orderDate} onChange={handleChange} sx={{ mb: 2 }} />
                        <TextField label="User Name" name="userName" fullWidth value={form.userName} onChange={handleChange} sx={{ mb: 2 }} />
                        <TextField label="Mobile Number" name="mobile" fullWidth value={form.mobile} onChange={handleChange} sx={{ mb: 2 }} />
                        <TextField label="Address" name="address" fullWidth multiline rows={2} value={form.address} onChange={handleChange} sx={{ mb: 2 }} />
                        <TextField select label="Order Status" name="status" fullWidth value={form.status} onChange={handleChange} sx={{ mb: 2 }}>
                            {orderStatuses.map((s) => <MenuItem key={s} value={s}>{s}</MenuItem>)}
                        </TextField>
                        <TextField label="Remarks" name="remarks" fullWidth value={form.remarks} onChange={handleChange} sx={{ mb: 2 }} />
                        <Typography variant="subtitle1" sx={{ mt: 2 }}>Products</Typography>
                        {form.products.map((p, i) => (
                            <Box key={i} sx={{ display: "flex", gap: 1, mb: 1 }}>
                                <TextField label="Product Name" fullWidth value={p.name} onChange={(e) => handleProductChange(i, "name", e.target.value)} />
                                <TextField label="Qty" type="number" sx={{ width: 100 }} value={p.quantity} onChange={(e) => handleProductChange(i, "quantity", e.target.value)} />
                            </Box>
                        ))}
                        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}>
                            <Button onClick={() => setOpen(false)}>Cancel</Button>
                            <Button variant="contained" onClick={saveOrder}>Save</Button>
                        </Box>
                    </Box>
                </Box>
            )}
        </Box>
    );
}